import React, {useEffect, useState} from "react";
import {auth, firebase, firestore} from "../firebase/clientApp";
import VoteContent from "../components/VoteContent";
import {useParams} from "react-router-dom";
import {Box, Container} from "@mui/material";
import {useDocument} from "react-firebase-hooks/firestore";
import axios from "axios";
import {API_URL} from "../config";
import LanguageSelector from "../components/shared/LanguageSelector";

const LogoBox = ({logo}) => {
  return (
    <Box pt={7} style={{width: '100%', height: '40%'}}>
      <img style={{margin: 'auto', width: '50%', height: '100%', objectFit: 'contain'}} src={logo}/>
    </Box>
  )
}

export default function Vote() {
  const {eventOwnerId, id} = useParams()
  const [user, setUser] = useState(null);
  const [event, eventLoading, eventError] = useDocument(firestore.doc(`users/${eventOwnerId}/events/${id}`))
  const [userData, setUserData] = useState({displayName: '', teamName: ''})

  const [loading, setLoading] = useState(true);

  async function loginUser() {
    await auth.signInAnonymously().then(() => {
    }).catch(alert);
  }

  useEffect(async () => {
    setLoading(true)
    await loginUser()
    firebase.auth().onAuthStateChanged(async (user) => {
      setUser(user);
      await axios.post(`${API_URL}users/${eventOwnerId}/events/${id}/users`, {user: user.uid})
        .then(res =>
          setUserData({displayName: res.data.displayName ?? '', teamName: res.data.teamName ?? ''})
        )
        .catch()
    })
    setLoading(false)
  }, [])

  if (loading) return <></>

  return (
    <Box sx={{position: 'relative'}}>
      {(event && !eventLoading && !eventError) &&
        <>
          <LanguageSelector eventData={event.data()}/>
          {event.data().logo &&
            <LogoBox logo={event.data().logoUrl ? event.data().logoUrl : 'https://storage.googleapis.com/2ndstage-public/logos/logo-2nd.png'}/>}
          <Container maxWidth={'sm'} className={'vote'} sx={{maxHeight: '100%', paddingX: 0}}>
            <VoteContent user={user} event={event} loading={loading} userData={userData} setUserData={setUserData}/>
          </Container>
        </>
      }
    </Box>
  )
}
